import type { StoryboardTestHarness } from "@storyboard/web-client/test-harness";

declare global {
  interface Window {
    __sbTestHarness__?: StoryboardTestHarness;
  }
}

/**
 * Returns the browser-test harness installed on `window` before the module graph evaluated, or undefined.
 *
 * Always undefined unless the bundle was built with `VITE_ENABLE_TEST_HARNESS=true`, so production builds never
 * honor an injected harness. See `StoryboardTestHarness` in `@storyboard/web-client/test-harness` for the contract
 * and the seams that consume it.
 */
export function activeTestHarness(): StoryboardTestHarness | undefined {
  if (import.meta.env.VITE_ENABLE_TEST_HARNESS !== "true") return undefined;
  return window.__sbTestHarness__;
}
